module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_bigginer-691005ffc84ce9c4f151f2222df7a59f.jpg";